import React from "react";
function Helpline(){
    return <div className="helpline">
        <h1><b>Hi,What can we help you with?</b></h1><br />
        <button className="helplinebutton"type="button"><h6>Log In</h6></button>
        <h4 className="trackorder">Login to see your order details, track order, cancel order return / replace order etc.</h4>
        <div>
            
            <table>
                <tr>
                    <ul><td><li><a href="www.mycart.com">How can I check my order status?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">How can I return/replace an item?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">What are the different modes of payment available?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">What is Questions & Answers?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">What is Snapcash?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">I have received a call/SMS/email asking for money</a></li></td></ul>
                </tr>
                </table>
            <table>
                <tr>
                    <ul><td><li><a href="www.mycart.com">How can I cancel my order?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">When can I expect refund for my returned item?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">I don't remember my password. Help!</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">What are digital products?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">How to raise query/complaint?</a></li></td></ul>
                    <ul><td><li><a href="www.mycart.com">I want to sell my items on Snapdeal. Who do I get in touch with?</a></li></td></ul>
                </tr>
                </table>
        </div>
        </div>
        
}
export default Helpline;
